import { atom } from 'recoil';

import * as K from 'common/constants';

const KEY = 'scalyrIsDebug';

const clearDebug = () => localStorage?.removeItem(KEY);

const setDebug = () => localStorage?.setItem(KEY, 'true');

export const isDebug = () => localStorage?.getItem(KEY) === 'true';

export const debugState = atom<boolean>({
  key: K.RECOIL_ATOM_KEY.DEBUG,
  default: false,
  effects: [
    ({ onSet, setSelf, trigger }) => {
      if (trigger === 'get') {
        setSelf(isDebug());
      }

      onSet((value) => {
        if (value === true) {
          setDebug();
        } else  {
          clearDebug();
        }
      });
    },
  ],
});
